import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import {
  MessageToastPayload,
  MessageToastService,
} from '../../../services/message-toast.service';

interface ToastMessage {
  id: number;
  label: string;
}

@Component({
  standalone: true,
  selector: 'zkh-message-toast',
  templateUrl: './message-toast.component.html',
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MessageToastComponent implements OnInit, OnDestroy {
  toast: ToastMessage | null = null;
  private counter = 0;
  private subscription?: Subscription;
  private hideTimeoutId?: number;

  constructor(
    private readonly messageToastService: MessageToastService,
    private readonly translate: TranslateService,
  ) {}

  ngOnInit() {
    this.subscription = this.messageToastService.toast$.subscribe(
      (payload: MessageToastPayload) => {
        this.toast = {
          id: ++this.counter,
          label: this.translate.instant(payload.key, payload.params),
        };

        if (this.hideTimeoutId) {
          window.clearTimeout(this.hideTimeoutId);
        }

        this.hideTimeoutId = window.setTimeout(() => this.clearToast(), 3000);
      },
    );
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    if (this.hideTimeoutId) {
      window.clearTimeout(this.hideTimeoutId);
    }
  }

  onHide() {
    this.clearToast();
  }

  private clearToast() {
    if (this.hideTimeoutId) {
      window.clearTimeout(this.hideTimeoutId);
      this.hideTimeoutId = undefined;
    }

    this.toast = null;
  }
}
